'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import ComplianceReportsHeader from './components/ComplianceReportsHeader';
import ComplianceReportsBoard from './components/ComplianceReportsBoard';

export default function ComplianceReportsPage() {
  return (
    <AppLayout>
      <div className="flex flex-col h-full min-h-screen bg-background">
        <ComplianceReportsHeader />
        <div className="flex-1 flex flex-col gap-4 p-5 overflow-auto">
          <ComplianceReportsBoard />
        </div>
      </div>
    </AppLayout>
  );
}
